import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {AuthService} from '../../shared/services/auth.service';
import { environment } from 'src/environments/environment';
import { Rate } from '../interface/rate';

@Injectable({
    providedIn: 'root'
})
export class MobilePackService {
    rate: any;
    private indexToRemove: BehaviorSubject<boolean>;
    private isModalSimOpen: BehaviorSubject<boolean>;
    private retryValidators: BehaviorSubject<boolean>;

    constructor(protected http: HttpClient, private auth: AuthService) {
        this.rate = new BehaviorSubject<any>(null);
        this.indexToRemove = new BehaviorSubject<any>(null);
        this.isModalSimOpen = new BehaviorSubject<boolean>(false);
        this.retryValidators = new BehaviorSubject<boolean>(false);
    }

    getHeaders() {
        const token = 'Bearer ' + this.auth.getToken();

        return new HttpHeaders({
            Authorization: token,
            'Content-Type': 'application/json'
        });
    }

    setRate(rate: Rate) {
        this.rate.next(rate);
    }

    getRate() {
        return this.rate.asObservable();
    }

    getRetryValidators() {
        return this.retryValidators.asObservable();
    }

    setRetryValidators(value) {
        this.retryValidators.next(value);
    }

    getIsModalSimOpen() {
        return this.isModalSimOpen.asObservable();
    }

    setIsModalSimOpen(value) {
        this.isModalSimOpen.next(value);
    }

    setIndexToRemove(index) {
        this.indexToRemove.next(index);
        setTimeout(() => this.indexToRemove.next(null));
    }

    getIndexToRemove() {
        return this.indexToRemove.asObservable();
    }

    getProviders() {
        return this.http.get(environment.amenaEndpoint + 'master/service-providers', {headers: this.getHeaders()});
    }
}
